import resourceUrl from './makeUrl';

/**
 * These variables are injected by webpack or use defaults
 */
export const DEFAULT_WIDTH_TO_HEIGHT_RATIO = typeof DEFAULT_IMAGE_RATIO !== 'undefined' ? DEFAULT_IMAGE_RATIO : 1;
export const DEFAULT_PADDING = typeof DEFAULT_IMAGE_PADDING !== 'undefined' ? DEFAULT_IMAGE_PADDING : 0;
export const DEFAULT_BACKGROUND_COLOR = typeof DEFAULT_IMAGE_BACKGROUND_COLOR !== 'undefined' ? DEFAULT_IMAGE_BACKGROUND_COLOR : '#FFFFFF';

export const imageWidths = new Map(
    Object.entries({
        ICON: 40,
        THUMBNAIL: 80,
        SMALL: 160,
        REGULAR: 320,
        LARGE: 640,
        LARGER: 960,
        XLARGE: 1280,
        XXLARGE: 1600,
        XXXLARGE: 2560
    })
);

// see all supported options in https://zetlen.github.io/hastily/globals.html#mappers
export const generateUrl = (imageURL, mediaBase) => (
    width,
    height,
    padding
) => {
    const finalHeight = Math.round(height);
    const finalWidth = Math.round(width);

    return resourceUrl(imageURL, {
        type: mediaBase,
        width: finalWidth,
        height: finalHeight,
        canvas: `${finalWidth -
            (padding === undefined ? DEFAULT_PADDING : padding)},${finalHeight -
            (padding === undefined ? DEFAULT_PADDING : padding)}`,
        'bg-color': DEFAULT_BACKGROUND_COLOR,
        pad: padding === undefined ? DEFAULT_PADDING : padding
    });
};

export const generateUrlFromContainerWidth = (
    imageURL,
    containerWidth,
    type = 'image-product',
    ratio = DEFAULT_WIDTH_TO_HEIGHT_RATIO
) => {
    debugger;
    const intrinsicWidth = (globalThis.devicePixelRatio || 1) * containerWidth;

    /**
     * Find the best width that is closest to the intrinsicWidth.
     */
    const actualWidth = Array.from(imageWidths, ([, value]) => value).reduce(
        (prev, curr) => {
            if (prev) {
                return Math.abs(intrinsicWidth - curr) <
                    Math.abs(intrinsicWidth - prev)
                    ? curr
                    : prev;
            } else {
                return curr;
            }
        },
        null
    );

    return generateUrl(imageURL, type)(actualWidth, actualWidth / ratio);
};

export const generateSrcset = (imageURL, type, ratio, padding) => {
    if (!imageURL || !type) return '';

    const imageRatio = ratio || DEFAULT_WIDTH_TO_HEIGHT_RATIO;
    const generateSrcsetUrl = generateUrl(imageURL, type);

    return Array.from(imageWidths, ([, value]) => value)
        .map(
            width =>
                `${generateSrcsetUrl(
                    Math.round(width),
                    Math.round(Math.round(width) / imageRatio),
                    padding
                )} ${width}w`
        )
        .join(',\n');
};
